import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MAX_LAYOUT_NAME_LENGTH } from '../const';
import { getSavedLayouts } from '../ducks/layouts';
import {
  hideModal,
  saveLayoutModalPageIdSelector,
  showGenericErrorModal,
} from '../ducks/modals';
import { useModalState } from '../utils/useModalState';
import { useSaveAccountLayout } from '../utils/useSaveAccountLayout';
import { Button } from './Button';
import { FormField } from './FormField';
import { Modal } from './Modal';

export function SaveLayoutModal({ show, onHide }) {
  const pageId = useSelector(saveLayoutModalPageIdSelector);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!pageId) {
      dispatch(hideModal());
    }
  }, [pageId]);
  const [name, setName] = useModalState(show, '');

  const saveAccountLayout = useSaveAccountLayout(pageId);
  const [loading, setLoading] = useModalState(show, false);

  const onSubmit = useCallback(async () => {
    setLoading(true);
    try {
      await saveAccountLayout(name);
      dispatch(getSavedLayouts());
      onHide();
    } catch (error) {
      console.error(error);
      dispatch(showGenericErrorModal());
    }
  }, [name, saveAccountLayout]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      onSubmit={onSubmit}
      disableHide={loading}
      footer={
        <>
          <Button variant="tertiary" onClick={onHide} width="140px">
            Cancel
          </Button>
          <Button
            variant="primary"
            type="submit"
            width="182px"
            loading={loading}
            disabled={!name}
          >
            Save
          </Button>
        </>
      }
    >
      <FormField
        type="text"
        label="Layout name"
        autoFocus
        value={name}
        onChange={setName}
        maxLength={MAX_LAYOUT_NAME_LENGTH}
      />
    </Modal>
  );
}
